export default "__VITE_ASSET__KzSiI2cy__"